import React from "react";

export default function ExcelIcon({ className = "w-5 h-5" }) {
  return (
    <svg
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        d="M14.5 2H6C4.89543 2 4 2.89543 4 4V20C4 21.1046 4.89543 22 6 22H18C19.1046 22 20 21.1046 20 20V7.5L14.5 2Z"
        fill="#107C41"
      />
      <path
        d="M14 2V7C14 7.55228 14.4477 8 15 8H20L14 2Z"
        fill="#185C37"
      />
      <path
        d="M7.5 17.5L9.6 13.5L7.7 9.5H9.6L10.6 11.8C10.7 12 10.8 12.3 10.9 12.6H10.95C11.05 12.3 11.15 12 11.25 11.8L12.3 9.5H14.1L12.2 13.5L14.3 17.5H12.4L11.1 14.9C11.05 14.75 10.98 14.5 10.95 14.3H10.9C10.85 14.5 10.8 14.75 10.7 14.9L9.4 17.5H7.5Z"
        fill="white"
      />
    </svg>
  );
}
